import React from 'react';
import { Helmet } from '@dr.pogodin/react-helmet';
import { SEO_CONFIG, SITE_CONFIG } from '../config';

const ORIGIN = `https://${SITE_CONFIG.BASE_URL.replace(/^https?:\/\//, '').replace(/^www\./, '')}`;

export default function SEOHelmet({
  title = `${SITE_CONFIG.AGENT.NAME} | Metro Atlanta Real Estate`,
  description = `Buy or sell a home across metro Atlanta with multilingual broker ${SITE_CONFIG.AGENT.NAME} of ${SITE_CONFIG.AGENT.BROKERAGE}.`,
  keywords = 'Atlanta real estate, Georgia homes for sale, bilingual Realtor, Spanish speaking real estate agent',
  path = '',
  canonical,
  ogImage = SEO_CONFIG.OG_IMAGE,
  jsonLd
}) {
  const cleanPath = path && path !== '/' ? `/${String(path).replace(/^\/+|\/+$/g, '')}` : '';
  const canonicalUrl = canonical || `${ORIGIN}${cleanPath}`;
  const social = [SEO_CONFIG.FACEBOOK_URL, SEO_CONFIG.INSTAGRAM_URL, SEO_CONFIG.LINKEDIN_URL, SEO_CONFIG.ZILLOW_URL].filter(Boolean);
  const agentSchema = {
    '@context': 'https://schema.org',
    '@type': 'RealEstateAgent',
    name: SITE_CONFIG.AGENT.NAME,
    url: ORIGIN,
    image: SEO_CONFIG.LOGO_URL,
    telephone: SITE_CONFIG.AGENT.PHONE,
    email: SITE_CONFIG.AGENT.EMAIL,
    identifier: `Georgia license ${SITE_CONFIG.AGENT.LICENSE}`,
    knowsLanguage: SITE_CONFIG.AGENT.LANGUAGES,
    areaServed: SITE_CONFIG.SERVICE_AREAS.map((name) => ({ '@type': 'City', name })),
    address: {
      '@type': 'PostalAddress',
      streetAddress: SEO_CONFIG.STREET_ADDRESS,
      addressLocality: SEO_CONFIG.CITY,
      addressRegion: SEO_CONFIG.STATE,
      postalCode: SEO_CONFIG.ZIP_CODE,
      addressCountry: SEO_CONFIG.COUNTRY
    },
    sameAs: social
  };
  const schemas = [agentSchema, ...(Array.isArray(jsonLd) ? jsonLd : jsonLd ? [jsonLd] : [])];

  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />
      <link rel="canonical" href={canonicalUrl} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:type" content="website" />
      <meta property="og:url" content={canonicalUrl} />
      <meta property="og:image" content={ogImage} />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={ogImage} />
      <meta name="geo.region" content="US-GA" />
      <meta name="geo.placename" content={`${SEO_CONFIG.CITY}, ${SEO_CONFIG.STATE}`} />
      {SEO_CONFIG.LATITUDE ? <meta name="geo.position" content={`${SEO_CONFIG.LATITUDE};${SEO_CONFIG.LONGITUDE}`} /> : null}
      <script type="application/ld+json">{JSON.stringify(schemas)}</script>
    </Helmet>
  );
}
